import { createPrismaDateColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/DateColumn.tsx';
import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn.tsx';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting.ts';
import { TableRowActionsMenu } from '@dealstack/frontend/shared/components/TableRowActionsMenu/TableRowActionsMenu.tsx';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TagRes } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

type Handlers = {
	onDelete: (tag: TagRes) => void;
};

type GetTagsTableColumnsParams = {
	handlers: Handlers;
	canEdit: boolean;
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>;
};

export const getTagsTableColumns = ({
	handlers,
	canEdit,
	tMipManage,
}: GetTagsTableColumnsParams): ExtendedColumnDef<TagRes>[] => {
	const { onDelete } = handlers;

	const columns: ExtendedColumnDef<TagRes>[] = [
		createTextColumn({
			id: 'name',
			headerText: tMipManage('root.classifiers.tags.list.column.name'),
			columnLabel: tMipManage('root.classifiers.tags.list.column.name'),
			accessorKey: 'name',
			showFilter: false,
			filterVariant: 'text',
		}),
		createPrismaDateColumn({
			id: 'createdAt',
			headerText: tMipManage('root.classifiers.tags.list.column.created_at'),
			columnLabel: tMipManage('root.classifiers.tags.list.column.created_at'),
			accessorKey: 'createdAt',
			enableSorting: true,
			enableColumnFilter: false,
		}),
	];

	if (canEdit) {
		columns.push({
			id: 'actions',
			header: '',
			enableSorting: false,
			enableColumnFilter: false,
			size: 56,
			cell: ({ row }) => (
				<TableRowActionsMenu
					options={[
						{
							label: tMipManage('root.classifiers.tags.list.action.delete'),
							onClick: () => onDelete(row.original),
						},
					]}
				/>
			),
		});
	}

	return columns;
};
